import { render, staticRenderFns } from "./MoreCode.vue?vue&type=template&id=2b16b5ea&scoped=true&"
import script from "./MoreCode.vue?vue&type=script&lang=js&"
export * from "./MoreCode.vue?vue&type=script&lang=js&"
import style0 from "./MoreCode.vue?vue&type=style&index=0&id=2b16b5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16b5ea",
  null
  
)

export default component.exports